import type { Maybe } from "@entrilia/shared/types.ts";
import type { DimensionGroup, DimensionsStructure, ReportType } from "../../../../../../api/types/svTypes.ts";

const isGroupSupported = (group: DimensionGroup, reportType: Maybe<ReportType>): boolean => {
  if (!group.supportedReportTypes) {
    return true;
  }
  return !!reportType && group.supportedReportTypes.includes(reportType);
};

const filterGroups = (groups: DimensionGroup[], reportType: Maybe<ReportType>): DimensionGroup[] => {
  return groups
    .filter((group) => isGroupSupported(group, reportType))
    .map((group) => ({ ...group, groups: filterGroups(group.groups ?? [], reportType) }));
};

export const filterDimensionsStructureByReportType = (
  structure: DimensionsStructure,
  reportType: Maybe<ReportType>
): DimensionsStructure => {
  return { ...structure, groups: filterGroups(structure.groups, reportType) };
};
